class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener('click',this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const target = event.target.closest('span')?.dataset.open ?? 'menu';
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event,target);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event, target) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', target);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-open');

    if (target == "menu_search") {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.querySelector('.submenu__item.is-active')?.classList.remove('is-active');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-open');
  }
}

customElements.define('details-modal', DetailsModal);
